import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersByEmailCampaignQuery } from "../graphql/queries";
import type {
  AnalyticsUsersByEmailCampaignQueryType,
  AnalyticsUsersByEmailCampaignQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersByEmailCampaignQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersByEmailCampaignQueryType,
    AnalyticsUsersByEmailCampaignQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersByEmailCampaignQueryType,
    AnalyticsUsersByEmailCampaignQueryVariablesType
  >(AnalyticsUsersByEmailCampaignQuery, options);
};
